module.exports = __webpack_public_path__ + "img/copy-gray.f47ebc37.svg";